<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'technician',
};
</script>
